export default "__VITE_ASSET__Bccd6LZV__"